import { Typography, Box, IconButton, Link } from "@mui/material";
import { Email } from "@mui/icons-material";
import { useSelector } from "react-redux";
import App_store_icon from "@/assets/icons/app-icons/app-store-badge.svg?react";
import Google_play_icon from "@/assets/icons/app-icons/google-play-badge.svg?react";
import { RootState } from "@/redux-store";

interface IProps {
}

const DownloadAppCard: React.FC<IProps> = () => {
  const partnerOption = useSelector((state: RootState) => state.dealer.partnerOption);
  return (
    <>
      <Typography
        variant="subtitle2"
        fontWeight={{ xs: 500, md: 700 }}
        marginBottom={2}
      >
        Your account has been successfully created!
      </Typography>
      
      <Typography variant="body2" color="text.secondary" mb={3} fontSize={18}>
      Download the TrackmateGPS app to log in with your new account and start testing the GPS devices you install.
      The app helps guide you through the setup and testing process during installation.
      </Typography>

      <Box
        display="flex"
        gap={2}
        justifyContent={{ xs: "space-around", sm: "start" }}
        mb={3}
      >
        <IconButton
          component="a"
          target="_blank"
          href="https://apps.apple.com/us/app/trackmategps/id1109000685?platform=iphone"
          sx={{ padding: 0 }}
        >
          <App_store_icon />
        </IconButton>
        <IconButton
          component="a"
          target="_blank"
          href="https://play.google.com/store/apps/details?id=com.fleetManagementServices.pinspot&hl=en&gl=US"
          sx={{ padding: 0 }}
        >
          <Google_play_icon />
        </IconButton>
      </Box>
      
      {partnerOption === 2 && (
        <Box
          display="flex"
          flexDirection={"column"}
          gap={0}
          justifyContent={{ xs: "space-around", sm: "start" }}
          mb={3}
        >
          <Typography variant="body2" color="text.secondary" fontSize={18} marginBlockStart={0}>
              To purchase GPS devices for resale, contact our sales team:
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <Email color="primary" sx={{ marginRight: "4px", marginTop: "2px" }} />
            <Link
              href="mailto:sales@trackmategps.com"
              underline="hover"
            >
              <Typography
                variant="subtitle1"
                component="span"
                sx={{ fontSize: 18 }}
              >
                sales@trackmategps.com
              </Typography>
            </Link>
          </Box>
        </Box>
      )}
    </>
  );
};

export default DownloadAppCard;